module.exports = __webpack_public_path__ + "img/client_icon_01.e637f92f.png";